import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { RateView } from '@redlink/components/molecules';

export const PreviewResumeSkillItem = memo(({ item: { title = '', rate } }) => {
  const { styles, colors } = useStyle();
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{title}</Text>
      <RateView
        color={colors.description}
        tintColor={colors.title}
        value={rate}
        starSize={15}
      />
      </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    borderRadius: 10,
    backgroundColor: colors.cardBackground,
  },
  text: {
    flex: 1,
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.subtitle,
    textAlign: 'left',
  },
}));
